// eslint-disable-next-line no-unused-vars
import { Card, Col, FloatButton, Row, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { env } from "../../../configs/EnvironmentConfig";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import log from "../../../assets/images/log.svg";

import loc from "../../../assets/images/loc.png";
import ApiConfig from "configs/ApiConfig";

const Stat = () => {
  // eslint-disable-next-line no-unused-vars
  const [todaymatches, settodayMatches] = useState([]);
  const [pastmatches, setpastMatches] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [upcomingmatches, setupcomingMatches] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const getDateFormat = (props, flag) => {
    const dFormat = "MMM DD, YYYY";
    if (typeof props === "object") {
      const { date, format = dFormat, isTime } = props || {};
      if (!date) return;
      if (isTime) return dayjs(date).format(`${format} hh:mm a`);
      return dayjs(date).format(format);
    } else {
      if (flag) return props ? dayjs(props) : dayjs();
      return props ? dayjs(props).format(`${dFormat}`) : dayjs();
    }
  };
  const [teamsInfo, setteamsInfo] = useState([]);
  // eslint-disable-next-line no-unused-vars
  // const teamsNameLogo = (values) => {
  //   const won = values?.teams?.[0]?.team === values?.won_by?.team ? 0 : 1;
  //   const filterlogohome = teamsInfo?.filter(
  //     (x) => x?._id === values?.teams?.[0]?.team
  //   )[0]?.logo;
  //   const filternamehome = teamsInfo?.filter(
  //     (x) => x?._id === values?.teams?.[0]?.team
  //   )[0]?.name;
  //   const filterscorehome = values?.teams?.[0]?.score;

  //   const filterlogoaway = teamsInfo?.filter(
  //     (x) => x?._id === values?.teams?.[1]?.team
  //   )[0]?.logo;
  //   const filternameaway = teamsInfo?.filter(
  //     (x) => x?._id === values?.teams?.[1]?.team
  //   )[0]?.name;
  //   const filterscoreaway = values?.teams?.[1]?.score;
  //   return (
  //     <>
  //       <span style={{ minWidth: "300px" }}>
  //         <span
  //           className="team_name_logo"
  //           style={{
  //             display: "inline-block",
  //             width: "80%",
  //             color: won === 0 ? "green" : "red",
  //           }}
  //         >
  //           <span
  //             style={{
  //               display: "inline-block",
  //               width: "200px",
  //               minWidth: "100px",
  //             }}
  //           >
  //             <img
  //               src={filterlogohome || (process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl')?log:'https://tcbl2.poindexters.ca/img/loc.jpg'}
  //               height="10px"
  //               width="10px"
  //               alt=""
  //             />
  //             <span className="ml-2">{filternamehome}</span>
  //           </span>
  //           <span>{filterscorehome}</span>
  //         </span>
  //         <span
  //           className="team_name_logo"
  //           style={{
  //             display: "inline-block",
  //             width: "80%",
  //             color: won === 1 ? "green" : "red",
  //           }}
  //         >
  //           <span
  //             style={{
  //               display: "inline-block",
  //               width: "200px",
  //               minWidth: "100px",
  //             }}
  //           >
  //             <img
  //               src={filterlogoaway || (process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl')?""https://leaguepro.s3.ca-central-1.amazonaws.com": "https://leaguepro.s3.ca-central-1.amazonaws.com"}
  //               height="10px"
  //               width="10px"
  //               alt=""
  //             />
  //             <span className="ml-2">{filternameaway}</span>
  //           </span>
  //           <span>{filterscoreaway}</span>
  //         </span>
  //       </span>
  //     </>
  //   );
  // };
  // const scoreColumns = [
  //   {
  //     title: (
  //       <span style={{ color: "#000000", fontSize: "18px", fontWeight: "700" }}>
  //         Game Time
  //       </span>
  //     ),
  //     dataIndex: "date",
  //     key: "date",
  //     width:'150px',
  //     render: (text) => {return (<><span>{getDateFormat({ date: text, format: 'hh:mm a' })}</span>{text && <span> - {dayjs(text).add(45,'minutes').format('hh:mm a')}</span>}</>)}
  //   },
  //   {
  //     title: (<span style={{ color: "#000000", fontSize: "18px", fontWeight: "700" }}>Home</span>),
  //     dataIndex: "team",
  //     key: "team",
  //     // filterSearch: true,
  //     // filters: [],
  //     width: "30px",
  //     render: (text, gl) => {
  //       return (
  //           <span>{gl?.home?.team?.name}</span>
  //       )
  //     }
  //   },
  //   {
  //     title: (<span style={{ color: "#000000", fontSize: "18px", fontWeight: "700" }}>Home Tier</span>),
  //     dataIndex: "tier",
  //     key: "tier",
  //     // filterSearch: true,
  //     // filters: [],
  //       filterSearch: false,
  //     width: "20px",
  //     render: (text, gl) => {
  //       return (
  //         <>
  //           <span>{gl?.home?.tier}</span>
  //         </>
  //       )
  //     }
  //   },
  //   {
  //   title: (<span style={{ color: "#000000", fontSize: "18px", fontWeight: "700" }}>Away</span>),
  //   dataIndex: "team",
  //   key: "team",
  //   filterSearch: false,
  //   // filterSearch: true,
  //   // filters: [],
  //   width: "30px",
  //   render: (text, gl) => {
  //     return (
  //       <>
  //         <span>{gl?.away?.team?.name}</span>
  //       </>
  //     )
  //   }
  // },
  //   {
  //     title: (<span style={{ color: "#000000", fontSize: "18px", fontWeight: "700" }}>Away Tier</span>),
  //     dataIndex: "tier",
  //     key: "tier",
  //     // filterSearch: true,
  //     // filters: [],
  //     width: "20px",
  //     render: (text, gl) => {
  //       return (
  //         <>
  //           <span>{gl?.away?.tier}</span>
  //         </>
  //       )
  //     }
  //   },
  //   {
  //     title: (<span style={{ color: "#000000", fontSize: "18px", fontWeight: "700" }}>Season</span>),
  //     dataIndex: "season",
  //     key: "season",
  //     // filters: [],
  //     // filterSearch: true,
  //     width: "30px",
  //     render: (text, record) => record?.sports_event?.name
  //   },
  //   {
  //     title: (<span style={{ color: "#000000", fontSize: "18px", fontWeight: "700" }}>League</span>),
  //     dataIndex: "league",
  //     key: "league",
  //     // filterSearch: true,
  //     // filters: [],
  //     width: "30px",
  //     render: (text, record) => record?.league?.name
  //   },
  // ];

  // eslint-disable-next-line no-unused-vars
  const dayspliter = (matches) => {
    const matchlist = [];
    matchlist[0] = [matches[0]];
    let j = 0;
    for (let i = 1; i < matches.length; i++) {
      if (
        dayjs(matches[i]?.date).format("YYYY-MM-DD") ===
        dayjs(matchlist[j]?.[0]?.date).format("YYYY-MM-DD")
      ) {
        matchlist[j].push(matches[i]);
      } else {
        matchlist[j + 1] = [matches[i]];
        j += 1;
      }
    }
    return matchlist;
  };
  const loadMatches = async (court = []) => {
    const courts = {};
    const courtsarray = [];
    const toDate = dayjs().add(15, "days").format("YYYY-MM-DD");
    const fromDate = dayjs().add(-1, "days").format("YYYY-MM-DD");
    const query = `?from=${fromDate}&to=${toDate}&limit=100`;
    const { data } = await axios.get(
      `${env?.API_ENDPOINT_URL}/settings/schedules${query}`
    );
    // eslint-disable-next-line no-unused-vars
    let v1 = data?.results?.forEach((item) => {
      if (!courts[item?.court?._id]) {
        courts[item?.court?._id] = item?.court?.name;
        courtsarray.push(item?.court);
      }
    });
    const todaymatch = data?.results?.filter((item) => {
      return (
        dayjs(item?.date).format("YYYY-MM-DD") ===
          dayjs().format("YYYY-MM-DD") &&
        (court.length ? court : courtsarray?.[0]?._id) === item?.court?._id
      );
    });
    const recentmatch = dayspliter(
      data?.results
        ?.filter((item) => {
          return dayjs(item?.date) <= dayjs(); //&& ((court.length)?court:courtsarray?.[0]?._id) === item?.court?._id
        })
        .sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        })
        ?.map((ee) => ({ ...ee, key: ee._id }))
    );
    let upcomingmatch = dayspliter(
      data?.results
        ?.filter((item) => {
          return dayjs(item?.date) > dayjs() && item?.status ==='Scheduled' //&& ((court.length)?court:courtsarray?.[0]?._id) === item?.court?._id
        })
        .sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        })
        ?.map((ee) => ({ ...ee, key: ee._id }))
    );
    //if (upcomingmatch?.[0]) upcomingmatch = [];
    let teams =[]
    upcomingmatch.flat()?.forEach((item)=>{
      teams.push(item?.home?.team?._id)
      teams.push(item?.away?.team?._id)
    })
    // console.log([...new Set(teams)],'teamsteams')
    // const response = await axios.post(
    //   `${env?.API_ENDPOINT_URL}/settings/get-teams-logo`,{teams:[...new Set(teams)]}
    // );
    // console.log(response,'responseresponse')
    const todaymatchlist =
      todaymatch?.map((ee) => ({ ...ee, key: ee._id })) ?? [];
    settodayMatches([...todaymatchlist]);
    setpastMatches([
      //...todaymatchlist.flat(),
      ...upcomingmatch.flat(),
    ]);
    setupcomingMatches();
    console.log(todaymatchlist, "todaymatchlist", recentmatch, upcomingmatch);
  };
  useEffect(() => {
    loadMatches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadTeamsInfo = async () => {
    const response = await axios.get(
      `${env?.API_ENDPOINT_URL}/settings/get-teams-logo`
    );
    setteamsInfo(response?.data?.teamsInfo);
  };
  useEffect(() => {
    if(!Boolean(teamsInfo?.[0])) {
    loadTeamsInfo();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const ref = useRef();
  const scrollLeft = () => {
    console.log(ref.current.scrollLeft, "ref.scrollLeft");
    ref.current.scrollTo({
      left: ref.current.scrollLeft - 1000,
      behavior: "smooth",
    });
  };
  const scrollRight = () => {
    console.log(ref.current.scrollLeft, "ref.scrollLeft");
    ref.current.scrollTo({
      left: ref.current.scrollLeft + 1000,
      behavior: "smooth",
    });
  };
  
  const [settings,setsettings]=useState({})
  // eslint-disable-next-line no-unused-vars
  const getaccountsettings = async () => {
    try {
      const response = await axios.get(`${env?.API_ENDPOINT_URL}/${ApiConfig.website.getaccountsettings}`);
      setsettings({...response?.data?.[0]})
      // form.setFieldsValue({homepage:response?.data?.[0]?.homepage,
      //   home:response?.data?.[0]?.hiddenmenu?.includes("/home"),
      //   rule:response?.data?.[0]?.hiddenmenu?.includes("/rule"),
      //   portal:response?.data?.[0]?.portal,
      //   rulelink:response?.data?.[0]?.rule
      // })
    } catch (error) {
      return [];
    }
  }
  useEffect(()=>{
    getaccountsettings()
  },[])
  return (
    <>
      {Boolean(pastmatches?.[0]) && <><FloatButton
        shape="square"
        type="default"
        style={{
          left: 0,
          top: 0,
          height: "206px",
          width: "30px",
          borderRadius: "0px",
          position: "absolute",
        }}
        onClick={() => scrollLeft()}
        icon={
          <span>
            <LeftOutlined
              style={{ color: "red", fontSize: "26px", fontWeight: "1700" }}
            />
          </span>
        }
      />
      <FloatButton
        shape="square"
        type="default"
        style={{
          right: 0,
          top: 0,
          height: "206px",
          width: "30px",
          borderRadius: "0px",
          borderLeft: "2px solid grey",
          position: "absolute",
        }}
        onClick={() => scrollRight()}
        icon={
          <span>
            <RightOutlined
              style={{ color: "red", fontSize: "26px", fontWeight: "1700" }}
            />
          </span>
        }
      /></>}
      <div
        ref={ref}
        style={{
          marginTop: "0px",
          marginBottom: "-100px",
          display: "flex",
          overflow: "scroll",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <span style={{ minWidth: "30px" }}></span>
        {/* <span style={{minHeight:'200px',minWidth:'30px',verticalAlign:'center',height:'200px', fontSize:'45px',fontWeight:'1200',color:'red'}}  onClick={()=>console.log('clicked')}><LeftOutlined onClick={()=>{console.log('clicked');slider.current.scrollBy(10,10)}}/></span> */}
        {Boolean(pastmatches?.[0]) && pastmatches?.map((item,index) => (
          <>{(dayjs(item?.date).format(`MMM DD, YYYY`)!==dayjs(pastmatches?.[index-1]?.date).format(`MMM DD, YYYY`) || index===0)&&
          <>
          <div style={{display:'flex',justifyContent:'center',justifyItems:'center',alignContent:'center',alignItems:'center',background:'#eeeeee',color:'#000',textAlign:'center',width:'60px',fontSize:'18px',fontWeight:'700',textTransform:'uppercase'}}>
          
            <span style={{}}>{dayjs(item?.date).format('ddd MMM DD')}</span>
          </div>
          </>}
          <span
            style={{
              marginTop: "0px",
              minWidth: "350px",
              height: "220px",
              borderLeft: "3px solid #eeeeee",
              borderRight: "3px solid #eeeeee",
              display: "inline-block",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px 5px 20px 5px",
              }}
            >
              {/* <div style={{textAlign:'center',marginTop:'5px',fontSize:"18px",fontWeight:'700',color:"#000"}}>{item?.court?.name}</div> */}
              <Row gutter={16}>
                <Col xs={24} sm={24} md={10}>
                <div style={{height:'120px',display:'flex',justifyContent:'center',justifyItems:'center',alignContent:'center',alignItems:'center'}}>
                  <img
                    src={Boolean(item?.home?.team?.logo)?item?.home?.team?.logo: (settings?.logo) || ((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?log:loc}
                    
                    height="80px"
                    width="80px"
                    alt=""
                  />
                  </div>
                  <div style={{ textAlign:'center', color:'#000',fontWeight:'700'  }}>
                    {item?.home?.team?.name.toUpperCase()}
                </div>
                </Col>
                <Col xs={24} sm={24} md={4}>
                <div style={{height:'120px',display:'flex',justifyContent:'center',justifyItems:'center',alignContent:'center',alignItems:'center'}}>
                  <span style={{ textAlign:'center', color:'#000',fontWeight:'700',fontSize:'18px' }}>VS</span>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={10}>
                  <div style={{height:'120px',display:'flex',justifyContent:'center',justifyItems:'center',alignContent:'center',alignItems:'center'}}>
                  <img
                    src={
                      Boolean(item?.away?.team?.logo) ?item?.away?.team?.logo:(settings?.logo) ||  ((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?log:loc
                    }
                    height="80px"
                    width="80px"
                    alt=""
                  />
                  </div>
                  <div style={{ textAlign:'center', color:'#000',fontWeight:'700' }}>
                    {item?.away?.team?.name.toUpperCase()}
                </div>
                </Col>
              </Row>
              
            </div>
            <span style={{ display:'inline-block',position:'relative',bottom:'7px',width:'100%',textAlign:'center', color:'#595959',fontWeight:'700',textTransform:'uppercase' }}>
              {item?.league?.name}{" "}
              {item?.sports_event?.name && (
                <span
                  style={{
                    padding: "0px 3px",
                    fontWeight: "700",
                    fontSize:'16px'
                  }}
                >
                  |
                </span>
              )}
              {item?.sports_event?.name}{" "}
              {item?.tier && (
                <span
                  style={{
                    padding: "0px 3px",
                    fontWeight: "700",
                    fontSize:'16px'
                  }}
                >
                  |
                </span>
              )}
              {((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl'))?`Tier ${item?.tier}`:item?.tier==='1'?'East':'West'}
              
            </span>
          </span>
          </>
        ))}
      </div>
      {/* <span style={{minHeight:'200px',minWidth:'30px',verticalAlign:'center',height:'200px', fontSize:'45px',fontWeight:'1200',color:'red',float:'right',position:'absolute'}}><RightOutlined /></span> */}
    </>
  );
};
export default Stat;
